import axios, { AxiosResponse } from 'axios'
import { UserDataApiInterface } from 'src/shared/types/user-data-api-interface'

export const getUserData = (): Promise<AxiosResponse<UserDataApiInterface>> => {
  return axios.get(`/api/user/user-data`)
}
